<template>
    <div>
        <v-card class="mb-5">
            <v-card-text>
                <filter-template :enable="$vuetify.breakpoint.mobile" class="row flex-column flex-lg-row">
                    <template #top>
                        <v-col>
                            <custom-input-text
                                    clearable
                                    hide-details
                                    label="Кредит №"
                                    v-model="filter.credit_number"
                            ></custom-input-text>
                        </v-col>
                    </template>
                    <template #body>
                        <v-col>
                            <custom-input-text
                                    clearable
                                    hide-details
                                    label="ФИО"
                                    v-model="filter.name"
                            ></custom-input-text>
                        </v-col>
                        <v-col>
                            <custom-input-text
                                    clearable
                                    hide-details
                                    label="Пасспорт"
                                    v-model="filter.passport"
                            ></custom-input-text>
                        </v-col>
                        <v-col>
                            <custom-date-picker
                                    clearable
                                    hide-details
                                    label="Дата от"
                                    v-model="filter.from"
                            />
                        </v-col>
                        <v-col>
                            <custom-date-picker
                                    clearable
                                    hide-details
                                    label="Дата до"
                                    v-model="filter.to"
                            />
                        </v-col>
                        <v-col>
                            <custom-select
                                    :items="PAYMENT_TYPES"
                                    clearable
                                    hide-details
                                    item-text="text"
                                    item-value="value"
                                    label="Тип платежа"
                                    v-model="filter.payment_type"
                            />
                        </v-col>
                    </template>
                    <template #footer>
                        <div class="col ma-n1 d-flex flex-column flex-lg-row">
                            <div class="pa-1">

                                <v-btn @click="filterList" color="primary"
                                       style="min-width: auto"
                                       width="100%">
                                    <v-icon small>fas fa-search</v-icon>
                                </v-btn>
                            </div>
                            <div class="pa-1">
                                <v-btn @click="clear" color="error"
                                       style="min-width: auto"
                                       width="100%">
                                    <v-icon small>fas fa-times</v-icon>
                                </v-btn>
                            </div>
                            <div class="pa-1">
                                <download-excel-transaction-list
                                        :filter="filter"
                                        width="100%"
                                />
                            </div>
                        </div>
                    </template>
                </filter-template>
            </v-card-text>
        </v-card>
    </div>
</template>


<script>
	import {PAYMENT_TYPES} from "@/utils/constants";
	import FilterTemplate from "@/components/ui/template-filter/TemplateFIlter";
	import DownloadExcelTransactionList from "@/components/transaction/DownloadExcelTransactionList";

	export default {
		name: 'transaction-filter',
		components: {DownloadExcelTransactionList, FilterTemplate},
		props: {
			mkos: {
				type: Array,
				default: () => []
			},
			filter: {
				type: Object,
				default() {
					return {}
				}
			},
			credits: {
				type: Array,
				default: () => []
			}
		},
		data() {
			return {
				PAYMENT_TYPES
			}
		},
		methods: {
			filterList() {
				this.$emit('change', this.filter)
			},
			clear() {
				this.filter = {
					id: null,
					credit_number: null,
					name: null,
					passport: null,
					from: null,
					to: null,
					date: null,
					branch: null,
					payment_type: null
				};
				this.$emit('update:filter', {
					id: null,
					credit_number: null,
					name: null,
					passport: null,
					from: null,
					to: null,
					date: null,
					branch: null,
					payment_type: null
				})
				this.$emit('change', this.filter)
			}

		}
	}
</script>
